import { ListChecks } from 'lucide-react';
import { useState } from 'react';
import {
  Card,
  EmptyState,
  ErrorState,
  Field,
  SelectMenu,
  SelectMenuItem,
  SkeletonRows,
} from '../../../components/ui';
import { useT } from '../../../i18n';
import { useAutomationTeams } from '../api';
import { ReadinessMatrix } from '../project/ReadinessMatrix';

/**
 * «Ready for tests» on the accounts page: TestRun showed it for any project of
 * any team. The matrix itself is the project page's (project/ReadinessMatrix);
 * here the user picks the project.
 */
export const ReadinessTab = () => {
  const { t } = useT();
  const teams = useAutomationTeams();
  const [picked, setPicked] = useState('');

  if (teams.error) {
    return (
      <Card>
        <ErrorState error={teams.error} onRetry={() => void teams.refetch()} />
      </Card>
    );
  }
  if (!teams.data) return <SkeletonRows rows={4} className="p-0" />;

  const projects = teams.data.flatMap((team) =>
    team.projects.map((p) => ({ id: p.id, name: `${team.name} · ${p.name}` })),
  );
  const selected = projects.some((p) => p.id === picked) ? picked : (projects[0]?.id ?? '');

  if (!selected) {
    return (
      <Card>
        <EmptyState
          icon={<ListChecks className="size-6" />}
          title={t('automation.accounts.readinessTab.noProjects')}
          description={t('automation.accounts.readinessTab.noProjectsHint')}
        />
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      <Field label={t('automation.accounts.readinessTab.project')} className="max-w-md">
        {({ id }) => (
          <SelectMenu id={id} value={selected} onValueChange={setPicked}>
            {projects.map((p) => (
              <SelectMenuItem key={p.id} value={p.id}>
                {p.name}
              </SelectMenuItem>
            ))}
          </SelectMenu>
        )}
      </Field>
      <ReadinessMatrix key={selected} projectId={selected} />
    </div>
  );
};
